
<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-dialog-content class="mat-typography">

  <form class="form-wrapper" [formGroup]="addButtonForm" autocomplete=off>

    <zeiterfassung-stufen class="stufenAnzeige"
                          [selectboxItems]="$projektSelectbox | async"
    >
    </zeiterfassung-stufen>

    <mat-form-field class="cacheSelect" appearance="outline" color="accent">
      <mat-label>{{ 'pages.timeDialog.cache' | translate }}</mat-label>
      <mat-select (ngModelChange)="selectProjects($event)" formControlName="cache">
        <mat-option *ngFor="let cacheNode of ($cache | async)" [value]="cacheNode.id">
          {{cacheNode.obersteProjektstufe.join(' - ')}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="colorSelecter">
    <input formControlName="color" type="radio" name="color" id="red1" value="#DB2828" />
    <label for="red1"><span class="red1"></span></label>

      <input formControlName="color" type="radio" name="color" id="orange1" value="#F2711C"/>
      <label for="orange1"><span class="orange1"></span></label>

    <input formControlName="color" type="radio" name="color" id="yellow1" value="#FBBD08"/>
    <label for="yellow1"><span class="yellow1"></span></label>

    <input formControlName="color" type="radio" name="color" id="olive1" value="#B5CC18"/>
    <label for="olive1"><span class="olive1"></span></label>

      <input formControlName="color" type="radio" name="color" id="green1" value="#21BA45" />
      <label for="green1"><span class="green1"></span></label>

    <input formControlName="color" type="radio" name="color" id="teal1" value="#00B5AD"/>
    <label for="teal1"><span class="teal1"></span></label>

    <input formControlName="color" type="radio" name="color" id="blue1" value="#2185D0"/>
    <label for="blue1"><span class="blue1"></span></label>

    <input formControlName="color" type="radio" name="color" id="violet1" value="#6435C9"/>
    <label for="violet1"><span class="violet1"></span></label>

    <input formControlName="color" type="radio" name="color" id="purple1" value="#A333C8"/>
    <label for="purple1"><span class="purple1"></span></label>

    <input formControlName="color" type="radio" name="color" id="pink1" value="#E03997"/>
    <label for="pink1"><span class="pink1"></span></label>

      <input formControlName="color" type="radio" name="color" id="black1" value="#000000"/>
      <label for="black1"><span class="black1"></span></label>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    *ngIf="stufe"
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="stufe.addButtonForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>

</mat-dialog-actions>

